<template>
  <el-row type="flex" align="middle" justify="space-between" class="entry-row">
    <el-col>
      <el-row>
        <b>{{ dateToFormat(entry.date, 'shortDateWithoutYear') }}</b>
        <b>{{ entry.state_numbers }}</b>
      </el-row>
      <el-row
        :class="+entry.master_approve_status === 1 ? 'dp_green' : 'dp_red'"
      >
        <b>{{ statuses[+entry.master_approve_status] }}</b>
      </el-row>
    </el-col>
    <div>
      <el-button
        type="success"
        class="mob-btn change-btn"
        @click="$emit('load', true, entry.index, bid)"
      >
        Изменить
      </el-button>
    </div>
  </el-row>
</template>

<script>
import { entryStatuses } from '@/datas/consts'

export default {
  name: 'EntryOnBid',
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    entry: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      statuses: entryStatuses,
    }
  },
}
</script>
